import { useCallback, useState } from "react";

export const useDisclosure = (defaultIsOpen?: boolean) => {
  const [isOpen, setIsOpen] = useState(defaultIsOpen || false);

  const onOpen = useCallback(() => setIsOpen(true), []);
  const onClose = useCallback(() => setIsOpen(false), []);
  const onToggle = useCallback(() => setIsOpen((previous) => !previous), []);

  return { isOpen, onOpen, onClose, onToggle };
};
